import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const creditProgramStatus = enumerated({
  active: 'Ativo',
  inactive: 'Inativo',
  closed: 'Encerrado',
})

export const creditProgramType = enumerated({
  bonus: 'Bônus',
  credit: 'Crédito',
})

export const creditProgramObject = z.object({
  id: z.string().uuid(),
  clientId: z.number().int(),
  name: z.string(),
  description: z.string().nullish(),
  activeYear: z.number().int(),
  status: creditProgramStatus,
  generalRules: z.string().nullish(),
  type: creditProgramType,
  sourceFilter: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const creditProgramCreateInputObject = creditProgramObject
  .pick({
    id: true,
    clientId: true,
    name: true,
    description: true,
    activeYear: true,
    status: true,
    generalRules: true,
    type: true,
  })
  .extend({
    id: creditProgramObject.shape.id.nullish(),
    clientId: creditProgramObject.shape.clientId.nullish(),
    status: creditProgramObject.shape.status.nullish(),
  })

export const creditProgramUpdateInputObject = creditProgramObject
  .pick({
    id: true,
    name: true,
    description: true,
    activeYear: true,
    status: true,
    generalRules: true,
    type: true,
  })
  .partial()
  .required({ id: true })

export type CreditProgramType = z.infer<typeof creditProgramObject>

export const propertyMap = {
  id: sql`credit_program.id`,
  clientId: sql`credit_program.client_id`,
  name: sql`credit_program.name`,
  description: sql`credit_program.description`,
  activeYear: sql`credit_program.active_year`,
  status: sql`credit_program.status`,
  generalRules: sql`credit_program.general_rules`,
  type: sql`credit_program.type`,
  sourceFilter: sql`credit_program.source_filter`,
  createdAt: sql`credit_program.created_at`,
  updatedAt: sql`credit_program.updated_at`,
  deletedAt: sql`credit_program.deleted_at`,
}

export default creditProgramObject
